import i18n from 'i18next';

const tt = (key, defaultValue) => i18n.t(key, { defaultValue });

export const AutomaticAlarmConstants = {
  GET_MACHINES_ALARM: 'GET_MACHINES_ALARM',
  GET_MACHINES_ALARM_REQUEST: 'GET_MACHINES_ALARM_REQUEST',
  GET_MACHINES_ALARM_SUCCESS: 'GET_MACHINES_ALARM_SUCCESS',
  GET_MACHINES_ALARM_FAILURE: 'GET_MACHINES_ALARM_FAILURE',
  RESET_STATE: 'RESET_STATE'
};

export const getListHeaders = (editMode, t = i18n.t.bind(i18n)) => ([
  {
    name: 'name',
    label: t('automaticAlarms.headers.asset', { defaultValue: 'Asset' }),
  },
  {
    name: 'area_name',
    label: t('automaticAlarms.headers.area', { defaultValue: 'Area' }),
  },
  {
    name: 'base_graph',
    label: t('automaticAlarms.headers.baseGraph', { defaultValue: 'Base Graph' }),
    noSorter: true
  },
  {
    name: 'warning_factor',
    label: t('automaticAlarms.headers.warningX', { defaultValue: 'WarningX' }),
    noSorter: true,
    alignCenter: !editMode
  },
  {
    name: 'critical_factor',
    label: t('automaticAlarms.headers.criticalX', { defaultValue: 'CriticalX' }),
    noSorter: true,
    alignCenter: !editMode
  },
  {
    name: 'threshold_type',
    label: t('automaticAlarms.headers.thresholdType', { defaultValue: 'Threshold Type' }),
    noSorter: true
  },
  {
    name: 'parameter',
    label: t('automaticAlarms.headers.parameter', { defaultValue: 'Parameter' }),
    noSorter: true
  },
  {
    name: 'alarm_completion_percent',
    label: t('automaticAlarms.headers.status', { defaultValue: 'Status' }),
    alignCenter: true,
  },
]);


export const AlarmListcolumnSizes = [20, 12.5, 12.5, 8, 8, 13, 17.5, 8.5];

export const MAX_MACHINES_PER_REQUEST = 25;

export const ParameterTypeEnum = {
  VIBRATION_RMS_VELOCITY: 'rms_velocity',
  VIBRATION_DEMOD_RMS: 'vibration_demod_rms_acceleration',
  VIBRATION_ACCELERATION_RMS: 'rms_acceleration',
  CURRENT_RMS: 'rms_current',
  TEMPERATURE: 'temperature',
  PRESSURE: 'pressure',
  ULTRASOUND: 'ultrasound'
};

export const getParameterOptions = (t = i18n.t.bind(i18n)) => ([
  {
    text: t('automaticAlarms.parameters.rmsVelocity', { defaultValue: 'RMS Velocity' }),
    value: ParameterTypeEnum.VIBRATION_RMS_VELOCITY,
    shortHand: t('automaticAlarms.parametersShort.rmsVelocity', { defaultValue: 'RMS Velocity' })
  },
  {
    text: t('automaticAlarms.parameters.demodRmsAcceleration', { defaultValue: 'Demod RMS Acceleration' }),
    value: ParameterTypeEnum.VIBRATION_DEMOD_RMS,
    shortHand: t('automaticAlarms.parametersShort.demodRmsAcceleration', { defaultValue: 'Demod RMS Acc' })
  },
  {
    text: t('automaticAlarms.parameters.rmsAcceleration', { defaultValue: 'RMS Acceleration' }),
    value: ParameterTypeEnum.VIBRATION_ACCELERATION_RMS,
    shortHand: t('automaticAlarms.parametersShort.rmsAcceleration', { defaultValue: 'RMS Acc' })
  },
  {
    text: t('automaticAlarms.parameters.rmsCurrent', { defaultValue: 'RMS Current' }),
    value: ParameterTypeEnum.CURRENT_RMS,
    shortHand: t('automaticAlarms.parametersShort.rmsCurrent', { defaultValue: 'RMS Current' })
  },
  {
    text: t('automaticAlarms.parameters.temperature', { defaultValue: 'Temperature' }),
    value: ParameterTypeEnum.TEMPERATURE,
    shortHand: t('automaticAlarms.parametersShort.temperature', { defaultValue: 'Temperature' })
  },
  {
    text: t('automaticAlarms.parameters.pressure', { defaultValue: 'Pressure' }),
    value: ParameterTypeEnum.PRESSURE,
    shortHand: t('automaticAlarms.parametersShort.pressure', { defaultValue: 'Pressure' })
  },
  {
    text: t('automaticAlarms.parameters.ultrasound', { defaultValue: 'Ultrasound' }),
    value: ParameterTypeEnum.ULTRASOUND,
    shortHand: t('automaticAlarms.parametersShort.ultrasound', { defaultValue: 'Ultrasound' })
  }
]);

export const getBaseGraphOptions = (t = i18n.t.bind(i18n)) => ([
  {
    text: t('automaticAlarms.baseGraph.thirtyDays', { defaultValue: '30 Days' }),
    value: '30_last_days'
  },
  {
    text: t('automaticAlarms.baseGraph.sixtyDays', { defaultValue: '60 Days' }),
    value: '60_last_days'
  },
  {
    text: t('automaticAlarms.baseGraph.ninetyDays', { defaultValue: '90 Days' }),
    value: '90_last_days'
  },
  {
    text: t('automaticAlarms.baseGraph.baseline', { defaultValue: 'Baseline' }),
    value: 'from_baseline'
  }
]);

export const getThresholdOptions = (t = i18n.t.bind(i18n)) => ([
  {
    text: t('automaticAlarms.threshold.multiplier', { defaultValue: 'Multiplier' }),
    value: 'multiplier'
  },
  {
    text: t('automaticAlarms.threshold.stdDev', { defaultValue: 'Std Dev' }),
    value: 'standard_deviation'
  },
  {
    text: t('automaticAlarms.threshold.offset', { defaultValue: 'Offset' }),
    value: 'offset'
  },
]);

export const getStatusOptions = () => ([
  {
    text: '0 - 25 %',
    value: 1,
    range: [0, 25]
  },
  {
    text: '25 - 50 %',
    value: 2,
    range: [25, 50]
  },
  {
    text: '50 - 75 %',
    value: 3,
    range: [50, 75]
  },
  {
    text: '75 - 100 %',
    value: 4,
    range: [75, 100]
  }
]);

export const MESSAGE = {
  applySettings: tt('automaticAlarms.messages.applySettings', 'Applying Settings...'),
  incompleteParameters: tt('automaticAlarms.messages.incompleteParameters', 'Incomplete Parameters'),
  incompleteSettingsError: tt('automaticAlarms.messages.incompleteSettingsError', 'Some of the settings are not configured correctly.'),
  multiSetText: tt('automaticAlarms.messages.multiSetText', 'Same settings will be applied to all the selected assets.'),
  noAssets: tt('automaticAlarms.messages.noAssets', 'No Assets found.'),
  noParameter: tt('automaticAlarms.messages.noParameter', 'No parameter found.'),
  noParameterError: tt('automaticAlarms.messages.noParameterError', 'Uncheck this asset'),
  progressMessage: tt('automaticAlarms.messages.progressMessage', 'Alarm thresholds are being computed in the background. You can safely navigate away. The status will be updated once thresholds are computed.'),
  progressTitle: tt('automaticAlarms.messages.progressTitle', 'Thresholds computation in progress...'),
  required: tt('common.required', 'Required'),
  warningGreaterThanCriticalError: tt('automaticAlarms.messages.warningGreaterThanCriticalError', 'WarningX < CriticalX'),
};

export const getAutomaticAlarmsMessages = (t = i18n.t.bind(i18n)) => ({
  applySettings: t('automaticAlarms.messages.applySettings', { defaultValue: 'Applying Settings...' }),
  incompleteParameters: t('automaticAlarms.messages.incompleteParameters', { defaultValue: 'Incomplete Parameters' }),
  incompleteSettingsError: t('automaticAlarms.messages.incompleteSettingsError', { defaultValue: 'Some of the settings are not configured correctly.' }),
  multiSetText: t('automaticAlarms.messages.multiSetText', { defaultValue: 'Same settings will be applied to all the selected assets.' }),
  noAssets: t('automaticAlarms.messages.noAssets', { defaultValue: 'No Assets found.' }),
  noParameter: t('automaticAlarms.messages.noParameter', { defaultValue: 'No parameter found.' }),
  noParameterError: t('automaticAlarms.messages.noParameterError', { defaultValue: 'Uncheck this asset' }),
  progressMessage: t('automaticAlarms.messages.progressMessage', { defaultValue: 'Alarm thresholds are being computed in the background. You can safely navigate away. The status will be updated once thresholds are computed.' }),
  progressTitle: t('automaticAlarms.messages.progressTitle', { defaultValue: 'Thresholds computation in progress...' }),
  required: t('common.required', { defaultValue: 'Required' }),
  warningGreaterThanCriticalError: t('automaticAlarms.messages.warningGreaterThanCriticalError', { defaultValue: 'WarningX < CriticalX' }),
});
